import { createSelector } from 'reselect';
import get from 'lodash/get';
import {
  graphDataOrEmptyObjectSelector,
  previousGraphDataOrEmptyObjectSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY } from '../PersonalInfoWorkflowConstants';

const dirtyGraphNodesSelector = createSelector(
  graphDataOrEmptyObjectSelector,
  previousGraphDataOrEmptyObjectSelector,
  (graphData, previousGraphData) => {
    const partnerName = get(graphData, `${BACKEND_KEY}.Partner.FirstName`);
    if (partnerName === get(previousGraphData, `${BACKEND_KEY}.Partner.FirstName`)) {
      return [];
    }
    return ['Income', 'Accounts', 'AccountOwners', 'DebtAccounts', 'Pensions', 'PensionOwners'];
  },
);

export default dirtyGraphNodesSelector;
